import { useState, useEffect } from "react";

export function useCountdown(registerDate: number, deadLine: number) {
  const [days, setDays] = useState("");
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");
  const padStart = (val: number) => val.toString().padStart(2, "0");

  useEffect(() => {
    if (registerDate) {
      const intervalId = setInterval(() => {
        const now = Date.now();
        const end = registerDate + deadLine;
        const left = end - now;
        if (left < 0) {
          clearInterval(intervalId);
          setDays("0");
          setHours("00");
          setMinutes("00");
          setSeconds("00");
        } else {
          const totalHours = Math.floor(left / (1000 * 60 * 60));
          const days = Math.floor(totalHours / 24);
          const hours = totalHours % 24;
          const minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((left % (1000 * 60)) / 1000);
          setDays(padStart(days));
          setHours(padStart(hours));
          setMinutes(padStart(minutes));
          setSeconds(padStart(seconds));
        }
      }, 1000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [registerDate, deadLine]);

  return {
    days,
    hours,
    minutes,
    seconds,
  };
}
